var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({staticStyle:{"object-fit":"contain"},attrs:{"src":require("@/assets/images/equifax.png"),"width":_vm.width}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }